module.exports = __webpack_public_path__ + "img/banner-search.7ee96a07.jpeg";